import { addMonths } from 'date-fns';
import type { ProductWithBundleId } from '~/models/CampaignModel';
import { ProductType } from '~/models/product/ProductType';
import type { ComparableSubscription } from '~/models/subscription-comparison/ComparableSubscriptions';
import { type BroadBandProduct, Fiber100, Fiber50, getNgtChannelId, NGTCommercialProductId } from './fiber-product.constants';

type SubscriptionId = 'fleksipakken' | 'strommepakken' | 'rikspakken';

const subscriptionFeatureMap = new Map<SubscriptionId, { channels: number; streamingServices: string[] }>([
  ['fleksipakken', { channels: 22, streamingServices: ['Max', 'TV 2 Play Basis med reklame'] }],
  ['strommepakken', { channels: 50, streamingServices: ['Max', 'TV 2 Play Basis', 'Nordisk Film+', 'BBC Nordic+', 'SkyShowtime'] }],
  [
    'rikspakken',
    { channels: 61, streamingServices: ['Max', 'TV 2 Play Basis', 'Nordisk Film+', 'BBC Nordic+', 'FilmFavoritter', 'SkyShowtime'] },
  ],
]);

const subscriptionToInternetMap = new Map<SubscriptionId, BroadBandProduct>([
  ['fleksipakken', Fiber50],
  ['strommepakken', Fiber100],
  ['rikspakken', Fiber100],
]);

export const mapSubsriptions = (subscriptions: ComparableSubscription[]) => {
  const subs = subscriptions.slice();
  subs.sort((a, b) => a.currentPrice - b.currentPrice);
  return subs
    .filter((s) => subscriptionToInternetMap.has(s.campaignUrl as any))
    .map((s) => ({
      ...s,
      // biome-ignore lint/style/noNonNullAssertion: check is done in filter
      internet: subscriptionToInternetMap.get(s.campaignUrl as any)!,
      // biome-ignore lint/style/noNonNullAssertion: check is done in filter
      features: subscriptionFeatureMap.get(s.campaignUrl as any)!,
    }));
};
export type MappedSubscription = ReturnType<typeof mapSubsriptions>[number];

export const getSavingsPercentage = (pkg: MappedSubscription) => {
  const totalOriginalPrice = pkg.originalPrice + pkg.internet.originalPrice;
  const totalCurrentPrice = pkg.currentPrice + pkg.internet.price;
  return Math.floor(((totalOriginalPrice - totalCurrentPrice) / totalOriginalPrice) * 100);
};

export const toProductBundle = (pkg: BroadBandProduct): ProductWithBundleId => {
  const product: ProductWithBundleId = {
    id: 'internet-product',
    bundleId: 'internet-bundle',
    isPreChosen: false,
    // @ts-expect-error
    displayData: {
      name: pkg.name,
    },
    productType: ProductType.Internet,
    offer: {
      // TODO: please move defenition to sanity if possible
      commercialProductId: NGTCommercialProductId,
      compositeId: `${NGTCommercialProductId}-0-0-12-${getNgtChannelId(pkg.name)}`,
      contractPeriod: 12,
      offerId: 0,
      listPriceId: 0,
    },
    pricing: {
      isRecurring: true,
      price: pkg.price,
      originalPrice: pkg.originalPrice,
      offerPeriodInMonths: 12,
      offerEndDate: addMonths(new Date(), 12).toISOString(),
    },
  };
  return product;
};
